/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_Canvas_Public_Data_WarningInputs */



/**
* | output |
* | --- |
* | "Anyone with the link can read this canvas's data." |
*
* @param {Artifact_Canvas_Public_Data_WarningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_canvas_public_data_warning = /** @type {((inputs?: Artifact_Canvas_Public_Data_WarningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_Canvas_Public_Data_WarningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Jeder mit dem Link kann die Daten dieses Canvas lesen.")
	return /** @type {LocalizedString} */ ("Anyone with the link can read this canvas's data.")
});